<div soho-busyindicator blockUI="true" displayDelay="-1" style="height:100%;" class="busy-sm">
    <div [ngClass]="{ 'module-nav-bar': true, 'is-anonymous': anonymousUser, 'not-mingle': !mingleMode }">
        <div soho-accordion
             class="accordion panel module-nav-accordion"
             data-options="{ allowOnePane: true, rerouteOnLinkClick: false }"
        >
            <div class="module-nav-header accordion-section" [ngClass]="{ 'lm-hide': anonymousUser || isGuestUser }">
                <soho-module-nav-switcher
                  #SohoModuleNavSwitcher
                  class="module-nav-switcher"
                  data-automation-id="lm-web-app-switcher"
                  [icon]="false"
                  [moduleButtonText]="webAppTitle"
                  [roleDropdownLabel]="webAppTitle"
                  [generate]="false"
                  [noSearch]="true"
                  [changeIconOnSelect]="true"
                  (modulebuttonclick)="onHome()"
                  (listcontextmenu)="onListContextMenu($event)"
                  (rolechange)="selectWebApp($event)">
                </soho-module-nav-switcher>
            </div>

            <lm-application-menu-search-field *ngIf="showSearch" class="module-nav-search-container accordion-section"
                [menuV3]="true"
                [model]="model"
                [collapsibleOnMobile]="false"
                [menuSearchMode]="menuSearchMode"
                (autoSearchMenu)="autoSearchMenu($event)"
                (fireMenuSearchEvent)="fireMenuSearchEvent($event)"
                (menuSearchCleared)="onMenuSearchCleared()">
            </lm-application-menu-search-field>

            <ng-container *ngIf="showSearch && menuSearchMode">
                <lm-application-menu-search #LMApplicationMenuSearchComponent
                    class="module-nav-main accordion-section"
                    [menuV3]="true"
                    [searchString]="searchString"
                    [menuSpecsByWebApp]="menuSpecsByWebApp"
                    [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
                    [dataSearchResults]="dataSearchResults"
                    [reportSearchResults]="reportSearchResults"
                    [systemSearchResults]="systemSearchResults"
                    (menuSearched)="onMenuSearched($event)"
                    (systemMenuItemClickEvent)="onSystemMenuItemClick($event)"
                    (menuLoaded)="onMenuLoaded($event)"
                    (menuSearchCleared)="onMenuSearchCleared()"
                ></lm-application-menu-search>
            </ng-container>
            <div class="module-nav-main accordion-section" [ngStyle]="{'display': (showSearch && menuSearchMode) ? 'none' : null }">
                <ng-container *ngFor="let menuItem of menuItemSpecs">
                    <ng-container *ngIf="menuItem.name !== 'Home'">
                        <div #AccordionHeaders
                             [ngStyle]="{'visibility': (menuItem.iconName === undefined || menuItem.iconUrl === undefined && !menuItem.validSohoIcon) && moduleNavDisplayMode === 'collapsed' ? 'hidden' : 'visible' }"
                             attr.id="{{menuItem.label}}-{{menuItem.menuIndex}}"
                             attr.menuindex="{{menuItem.menuIndex}}"
                             attr.data-automation-id="{{headerAutomationId(menuItem)}}"
                             class="accordion-header"
                             (contextmenu)="onMenuItemRightClicked($event, menuItem)"
                             (click)="onModuleNavClick($event, menuItem)">
                            <ng-container *ngIf="menuItem.validSohoIcon">
                                <svg soho-icon icon="{{menuItem.iconName}}"></svg>
                            </ng-container>
                            <ng-container *ngIf="!menuItem.validSohoIcon && menuItem.iconUrl">
                                <img class="icon" src="{{menuItem.iconUrl}}"/>
                            </ng-container>
                            <a href="#"
                                attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                                attr.id="{{menuItem.id}}"
                                attr.data-automation-id="{{dataAutomationId(menuItem)}}"
                            ><span>{{menuItem?.label}}</span></a>
                        </div>
                        <lm-application-menu-submenu
                            #ApplicationMenuSubmenus
                            *ngIf="menuItem.menu"
                            [ngClass]="{'accordion-pane': menuItem.menu, 'has-icons': menuItem.iconName !== undefined}"
                            [menuItemSpecs]="menuItem.menu"
                            (menuLoaded)="onMenuLoaded($event)">
                        </lm-application-menu-submenu>
                    </ng-container>
                </ng-container>
            </div>
            <!-- pinned items -->
            <div *ngIf="!searchMode" class="module-nav-footer accordion-section">
                <div *ngIf="inbasketEnabled && inbasketButton && inbasketButton.url"
                     class="accordion-header"
                     attr.data-automation-id="{{inbasketButton.automationId}}"
                     (click)="openLink(inbasketButton.url)"
                >
                    <svg soho-icon [icon]="inbasketButton.icon" attr.title="{{inbasketButton.label}}"></svg>
                    <a href="{{inbasketButton.url}}">
                        <span>{{inbasketButton.label | translate}}</span>
                    </a>
                </div>
                <div *ngIf="notificationEnabled && notificationsButton && notificationsButton.url"
                     style="position: relative;"
                     class="accordion-header"
                     (click)="openLink(notificationsButton.url)"
                     attr.data-automation-id="{{notificationsButton.automationId}}"
                >
                    <span [ngClass]="{'red-dot' : displayRedDot }"
                        [ngStyle]="{
                            'left': moduleNavDisplayMode === 'collapsed' ? '21px' : '19px',
                            'top': moduleNavDisplayMode === 'collapsed' ? '13px' : '13px'
                        }"
                    ></span>
                    <svg soho-icon [icon]="notificationsButton.icon" attr.title="{{notificationsButton.label}}"></svg>
                    <a href="{{notificationsButton.url}}">
                        <span>{{notificationsButton.label | translate}}</span>
                    </a>
                </div>
                <div *ngIf="reportsButton && reportsButton.url"
                     class="accordion-header"
                     attr.data-automation-id="{{reportsButton.automationId}}"
                     (click)="openLink(reportsButton.url)"
                >
                    <svg soho-icon [icon]="reportsButton.icon" attr.title="{{reportsButton.label}}"></svg>
                    <a href="{{reportsButton.url}}">
                        <span>{{reportsButton.label}}</span>
                    </a>
                </div>
                <div *ngIf="printFilesButton && printFilesButton.url"
                    class="accordion-header"
                    attr.data-automation-id="{{printFilesButton.automationId}}"
                    (click)="openLink(printFilesButton.url)"
                >
                    <svg soho-icon [icon]="printFilesButton.icon" attr.title="{{printFilesButton.label}}"></svg>
                    <a href="{{printFilesButton.url}}">
                        <span>{{printFilesButton.label}}</span>
                    </a>
                </div>

                <div *ngIf="signOutLink && (!mingleMode && !insideInforGo)" class="accordion-header"
                    data-automation-id="lm-appmenu-logout-button"
                    (click)="openSecurityLink(signOutLink)"
                >
                    <svg soho-icon [icon]="'logout'" attr.title="{{isGuestUser ? 'Exit' : 'SignOut' | translate }}"></svg>
                    <a id="Logout_button">
                        <span>{{isGuestUser ? 'Exit' : 'SignOut' | translate }}</span>
                    </a>
                </div>

                <ng-container *ngIf="anonymousUser">
                    <div *ngIf="clientLogin"
                        class="accordion-header"
                        data-automation-id="lm-appmenu-login-button"
                        (click)="openLoginWindow()"
                    >
                        <svg soho-icon [icon]="'login'" attr.title="{{ 'SignIn' | translate }}"></svg>
                        <a href="javascript:void(0);">
                            <span>{{ 'SignIn' | translate }}</span>
                        </a>
                    </div>
                    <div *ngIf="!clientLogin"
                        class="accordion-header"
                        data-automation-id="lm-appmenu-login-button"
                        (click)="openSecurityLink(signInLink)"
                    >
                        <svg soho-icon [icon]="'login'" attr.title="{{ 'SignIn' | translate }}"></svg>
                        <a href="javascript:void(0);">
                            <span>{{ 'SignIn' | translate }}</span>
                        </a>
                    </div>
                    <div *ngIf="hasRegisterLink"
                        class="accordion-header"
                        data-automation-id="lm-appmenu-register-button"
                        (click)="openLink(registerLink)"
                    >
                        <svg soho-icon [icon]="'locked'" attr.title="{{ 'Register' | translate }}"></svg>
                        <a href="javascript:void(0);">
                            <span>{{ 'Register' | translate }}</span>
                        </a>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="!anonymousUser && !isGuestUser" [ngStyle]="{'display': !searchMode ? 'block' : 'none'}" class="module-nav-settings accordion-section">
                <soho-module-nav-settings>
                    <div soho-menu-button
                         id="module-nav-settings-btn"
                         class="module-nav-settings-btn accordion-header"
                         title="{{'More' | translate}}"
                         data-automation-id="lm-appmenu-settings-menu-button"
                         [icon]="'settings'"
                         [hideMenuArrow]="true"
                         [showArrow]="false"
                         [returnFocus]="true"
                         [ripple]="false"
                         [menu]="'module-nav-settings-menu'">
                        <a href="#"><span>{{'More' | translate}}</span></a>
                    </div>
                    <ul soho-popupmenu id="module-nav-settings-menu" class="module-nav-settings-menu" data-automation-id="lm-appmenu-settings-menu">
                        <ng-container *ngFor="let button of applicationMenuButtons" >
                            <li soho-popupmenu-item *ngIf="button.url" id="{{button.id}}" (click)="openLink(button.url)">
                                <a soho-popupmenu-label href="" attr.data-automation-id="{{button.automationId}}">
                                    <svg soho-icon [icon]="button.icon"></svg>
                                    <span>{{ button.label }}</span>
                                </a>
                            </li>
                        </ng-container>
                        <li *ngIf="allowSetAsOfDate
                            || showProxy
                            || enableUserContextMenu
                            || createReportUrl && !reportsButton"
                            soho-popupmenu-separator class="separator"
                        ></li>

                        <li soho-popupmenu-item *ngIf="allowSetAsOfDate" (click)="openSetAsOfDateDialog()">
                            <a hsoho-popupmenu-label href="" data-automation-id="lm-appmenu-set-as-of-date-button">
                                <svg soho-icon [icon]="'calendar'"></svg>
                                <span>{{ 'AsOfDateLabel' | translate }}</span>
                            </a>
                        </li>

                        <li soho-popupmenu-item *ngIf="showProxy" (click)="openProxyPage()">
                            <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-proxy-button">
                                <span>{{ 'Proxy' | translate }}</span>
                            </a>
                        </li>

                        <li soho-popupmenu-item *ngIf="enableUserContextMenu" (click)="openSetUserContextDialog()">
                            <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-user-context-button">
                                <span>{{ 'ActorContextMenuLabel' | translate }}</span>
                            </a>
                        </li>

                        <li soho-popupmenu-item *ngIf="reportsButton" (click)="runCreateReport()">
                            <a soho-popupmenu-label href="" data-automation-id="lm-appmenu-create-report-button">
                                <span>{{ 'CreateReport' | translate }}</span>
                            </a>
                        </li>

                        <li *ngIf="hasChangePasswordLink || appHelpLink || aboutLink" soho-popupmenu-separator class="separator"></li>

                        <li soho-popupmenu-item  *ngIf="hasChangePasswordLink" (click)="openChangePasswordWindow()">
                            <a soho-popupmenu-label
                                id="ChangePassword_button"
                                data-automation-id="lm-appmenu-change-password-button"
                            >{{ 'ChangePassword' | translate }}</a>
                        </li>

                        <li soho-popupmenu-item *ngIf="!hasChangePasswordLink" (click)="openUserSettingsDialog()">
                            <a soho-popupmenu-label id="Settings_button" href="" data-automation-id="lm-appmenu-settings-button">
                                <svg soho-icon [icon]="'advance-settings'"></svg>
                                <span>{{ 'Settings' | translate }}</span>
                            </a>
                        </li>
                        <li soho-popupmenu-item *ngIf="appHelpLink && !hasChangePasswordLink" (click)="openHelpLink()">
                            <a soho-popupmenu-label id="Help_button" href="" data-automation-id="lm-appmenu-help-button">
                                <svg soho-icon [icon]="'help'"></svg>
                                <span>{{ 'Help' | translate }}</span>
                            </a>
                        </li>
                        <li soho-popupmenu-item *ngIf="aboutLink && !hasChangePasswordLink" (click)="openLink(aboutButton.url)">
                            <a soho-popupmenu-label id="About_button" href="" data-automation-id="lm-appmenu-about-button">
                                <svg soho-icon [icon]="'info-linear'"></svg>
                                <span>{{ 'About' | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </soho-module-nav-settings>
            </div>

            <ng-container *ngIf="mingleMode && proxyMode; else NotProxy;">
                <div class="application-menu-actor-info-container is-proxy">
                    <h2 data-automation-id="lm-appmenu-actor-name" class="actor-name">{{actorName}}</h2>
                </div>
            </ng-container>
            <ng-template #NotProxy>
                <div *ngIf="!mingleMode && !insideInforGo" class="module-nav-guest accordion-section">
                    <a href="javascript:void(0);" class="module-nav-guest-link">
                        <div *ngIf="noActorUrl()"  class="avatar round {{actorInitialsColorClass}}">{{actorInitials}}</div>
                        <img *ngIf="!noActorUrl()" class="avatar round" [src]="actorUrl" alt=""/>
                        <div class="module-nav-guest-text">
                            <span class="module-nav-guest-title">{{ 'Welcome' | translate }},</span>
                            <span class="module-nav-guest-subtext" data-automation-id="lm-appmenu-actor-name">{{actorName}}</span>
                        </div>
                    </a>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<div #menuFormDialog>
    <!-- dialog placeholder used to display action form from menu -->
</div>